"use strict";
exports.__esModule = true;
exports.HEIGHT_OF_SIZE_LEGEND = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
exports.HEIGHT_OF_SIZE_LEGEND = 161;
function PushpinCategoryLegend(props) {
    var contentRect = props.contentRect, hasSizeLegend = props.hasSizeLegend, isFluidLegend = props.isFluidLegend, renderPopUp = props.renderPopUp, _a = props.isSizeLegendVisible, isSizeLegendVisible = _a === void 0 ? true : _a;
    if (renderPopUp) {
        return react_1["default"].createElement(GeoPopUpLegend, tslib_1.__assign({}, props, { isSizeLegendVisible: isSizeLegendVisible }));
    }
    return (react_1["default"].createElement("div", { className: "s-geo-category-legend" }, isFluidLegend
        ? renderFluidCategoryLegend(props, contentRect)
        : renderStaticCategoryLegend(props, contentRect, hasSizeLegend)));
}
exports["default"] = PushpinCategoryLegend;
function renderFluidCategoryLegend(props, contentRect) {
    var categoryItems = props.categoryItems, onItemClick = props.onItemClick;
    var legendProps = {
        series: categoryItems !== null && categoryItems !== void 0 ? categoryItems : [],
        onItemClick: onItemClick
    };
    var contentRectClient = contentRect.client;
    var usedWidth = contentRectClient && contentRectClient.width ? Math.floor(contentRectClient.width) : 0;
    return react_1["default"].createElement(sdk_ui_vis_commons_1.FluidLegend, tslib_1.__assign({}, legendProps, { containerWidth: usedWidth }));
}
function renderStaticCategoryLegend(props, contentRect, hasSizeLegend) {
    var _a = props.categoryItems, categoryItems = _a === void 0 ? [] : _a, _b = props.position, position = _b === void 0 ? "top" : _b, height = props.height, format = props.format, locale = props.locale, onItemClick = props.onItemClick, responsive = props.responsive;
    // For Geo Pushpin with position left/right
    // we set the height of series to number of actual displayed items
    // so that, size legend will be visible
    var shouldFillAvailableSpace = position !== "left" && position !== "right";
    var legendProps = {
        format: format,
        locale: locale,
        position: position,
        responsive: responsive,
        series: categoryItems,
        shouldFillAvailableSpace: shouldFillAvailableSpace,
        onItemClick: onItemClick
    };
    var contentRectClient = contentRect.client;
    var hasSizeAndLeftRightPosition = hasSizeLegend && (position === sdk_ui_vis_commons_1.LegendPosition.LEFT || position === sdk_ui_vis_commons_1.LegendPosition.RIGHT);
    var measuredHeight = contentRectClient && contentRectClient.height ? Math.floor(contentRectClient.height) : 0;
    var usedHeight = (height || measuredHeight) - (hasSizeAndLeftRightPosition ? exports.HEIGHT_OF_SIZE_LEGEND : 0);
    return react_1["default"].createElement(sdk_ui_vis_commons_1.StaticLegend, tslib_1.__assign({}, legendProps, { containerHeight: usedHeight }));
}
function GeoPopUpLegend(props) {
    var containerId = props.containerId, _a = props.categoryItems, categoryItems = _a === void 0 ? [] : _a, _b = props.onItemClick, onItemClick = _b === void 0 ? noop_1["default"] : _b, name = props.name, maxRows = props.maxRows, customComponent = props.customComponent, customComponentName = props.customComponentName, hasSizeLegend = props.hasSizeLegend, isSizeLegendVisible = props.isSizeLegendVisible;
    return (react_1["default"].createElement(sdk_ui_vis_commons_1.PopUpLegend, { series: categoryItems, onLegendItemClick: onItemClick, maxRows: hasSizeLegend && isSizeLegendVisible && maxRows ? maxRows - 1 : maxRows, name: name, containerId: containerId, customComponent: customComponent, customComponentName: customComponentName }));
}
//# sourceMappingURL=PushpinCategoryLegend.js.map